import React from 'react';
import { Sparkle } from 'lucide-react';
import './pixlesCoin.css';

interface PixlesCoinProps {
  /** Badge diameter in px. The sparkle glyph scales with it. */
  size?: number;
}

/**
 * Shared pixles (credit) coin badge: a glossy purple orb with a white
 * sparkle, matching the brand artwork. Replaces the flat 🪙 emoji so the
 * icon renders consistently instead of depending on the platform emoji font.
 */
const PixlesCoin: React.FC<PixlesCoinProps> = ({ size = 34 }) => (
  <span
    className="pixles-coin"
    aria-hidden="true"
    style={{ '--pixles-coin-size': `${size}px` } as React.CSSProperties}
  >
    <Sparkle
      size={Math.round(size * 0.52)}
      strokeWidth={1.5}
      fill="currentColor"
    />
  </span>
);

export default PixlesCoin;
